<template>
  <div class="fullheight">
    <eco-table
      @load="loadData"
      :data="data"
      :pageResult="pageResult"
      quick-search-props="subject,senderName,content"
      ref="ecoTable"
      :show-export="false"
    >
      <template v-slot:toolbar>
        <el-button-group>
          <fe-delete-button :url="deleteUrl" :htTable="$refs.ecoTable" @after-delete="afterDelete">删除</fe-delete-button>
        </el-button-group>
      </template>

      <template>
        <eco-table-column type="index" width="50" align="center" label="序号" />
        <eco-table-column prop="subject" label="标题" :sortable="true" :show-overflow-tooltip="true">
          <template v-slot="{row}">
            <el-link type="primary" @click="openDetail(row)" title="查看明细">{{row.subject}}</el-link>
          </template>
        </eco-table-column>
        <eco-table-column prop="type" label="消息类型" width="100" :filters="typeArray">
          <template v-slot="{row}">
            <el-tag
              v-show="row.type==s.value"
              type="info"
              v-for="s in typeArray"
              :key="s.value"
            >{{s.text}}</el-tag>
          </template>
        </eco-table-column>
        <eco-table-column prop="isSuccess" label="状态" width="80" :filters="statusArray">
          <template v-slot="{row}">
            <el-tag
              v-show="row.isSuccess==s.value"
              :type="s.type"
              v-for="s in statusArray"
              :key="s.value"
            >{{s.text}}</el-tag>
          </template>
        </eco-table-column>

        <eco-table-column prop="senderName" label="发送人" width="120" />
        <eco-table-column prop="content" label="消息内容" :show-overflow-tooltip="true" />
        <eco-table-column prop="retryCount" width="80" label="重试次数" />
        <eco-table-column prop="createTime" label="记录时间" width="140" />

        <eco-table-column align="left" width="180" label="操作" :fixed="'right'">
          <template v-slot="{row}">
            <el-link @click="reinvoke(row.id)" :underline="false" type="primary">重调</el-link>
            <el-link v-show="!row.isSuccess" @click="signSuccess(row.id)" class="marginLeft16" :underline="false" type="primary">标记为成功</el-link>
          </template>
        </eco-table-column>
      </template>
    </eco-table>
    <eco-sidebar-dialog
    destroy-on-close
      width="28%"
      title="日志明细"
      append-to-body
      :visible="dialogVisible"
      :before-close="handleClose"
    >
      <el-form v-model="curRow" data-vv-scope="editRoleForm" style="padding: 20px">
        <eco-form-item label="类型" prop="name" label-width="80px">
          <el-tag
            v-show="curRow.type==s.value"
            :type="s.type"
            v-for="s in typeArray"
            :key="s.value"
          >{{s.text}}</el-tag>
        </eco-form-item>

        <eco-form-item label="发送人" prop="name" label-width="80px">{{curRow.senderName}}</eco-form-item>
        <eco-form-item label="接收人" prop="receivers" label-width="80px">
          <eco-input type="textarea" v-model="curRow.receivers" :rows="2" :readonly="true" />
        </eco-form-item>
        <eco-form-item label="标题" prop="subject" label-width="80px">{{curRow.subject}}</eco-form-item>
        <eco-form-item label="消息内容" prop="content" label-width="80px">
          <eco-input type="textarea" v-model="curRow.content" :rows="2" :readonly="true" />
        </eco-form-item>
        <eco-form-item label="状态" prop="isSuccess" label-width="80px">
          <el-tag
            v-show="curRow.isSuccess==s.value"
            :type="s.type"
            v-for="s in statusArray"
            :key="s.value"
          >{{s.text}}</el-tag>
        </eco-form-item>
        <eco-form-item label="异常信息" prop="exception" label-width="80px">
          <eco-input type="textarea" v-model="curRow.exception" :rows="2" :readonly="true" />
        </eco-form-item>
        <eco-form-item label="重试次数" prop="name" label-width="80px">{{curRow.retryCount}}</eco-form-item>
        <eco-form-item label="记录时间" prop="createTime" label-width="80px">{{curRow.createTime}}</eco-form-item>
      </el-form>
    </eco-sidebar-dialog>
  </div>
</template>
<script>
import req from "@/request.js";
export default {
  components: {},
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "name"
      },
      data: [],
      pageResult: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      curRow: {},
      dialogVisible: false,
      statusArray: [
        { text: "失败", value: "0", type: "danger" },
        { text: "成功", value: "1", type: "info" }
      ],
      typeArray: [
        { text: "内部消息", value: "inner" },
        { text: "邮件", value: "mail" },
        { text: "短信", value: "sms" },
        { text: "语音", value: "voice" },
        { text: "微信", value: "wxEnterprise" },
        { text: "钉钉", value: "dingTalk" },
      ]
    };
  },
  computed: {
    deleteUrl: function() {
      return window.context.portal + "/portal/messageLog/v1/removes";
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    openDetail(row) {
      this.curRow = row;
      this.dialogVisible = true;
    },
    loadData(param, cb) {
      req
        .post(req.getContext().portal + "/portal/messageLog/v1/list", param)
        .then(data => {
          let response = data.data;
          this.data = response.rows;
          this.pageResult = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          };
        })
        .finally(() => cb());
    },
    afterDelete() {
      this.$refs.ecoTable.load();
    },
    reinvoke(id) {
      let this_ = this;
      req
        .post(req.getContext().portal + "/portal/messageLog/v1/reinvoke/" + id)
        .then(function(response) {
          let data = response.data;
          if (data.state) {
            this_.$message.success(data.message);
            this_.$refs.ecoTable.load();
          } else {
            this_.$message.fail(data.message);
          }
        });
    },
    signSuccess(id) {
      let this_ = this;
      req
        .post(
          req.getContext().portal + "/portal/messageLog/v1/signSuccess/" + id
        )
        .then(function(response) {
          let data = response.data;
          if (data.state) {
            this_.$message.success(data.message);
            this_.$refs.ecoTable.load();
          } else {
            this_.$message.fail(data.message);
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
.aside-width {
  width: $--aside-width !important;
}
</style>